module.exports = __webpack_public_path__ + "static/media/forgot_image.7aa986ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/forgot_image.png
// module id = 1601
// module chunks = 0